










import {Component, Prop} from 'vue-property-decorator'
import VueBase from '@/pages/vue-base'

@Component
export default class ListCount extends VueBase {
  @Prop({ type: Number, default: 0}) readonly count: number
}
